module.exports = __webpack_public_path__ + "img/icon_drawer_logo.715c5783.svg";